import { Pipe, PipeTransform } from '@angular/core';
import { Filter, SelectFilter } from '@models/filter-types';
import { isSelectFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isSelectFilter',
    standalone: false,
})
export class IsSelectFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is SelectFilter<unknown> {
        return isSelectFilter(value);
    }
}
